module.exports = "/assets/e171bb69f95149374d9b2dbb42c78757.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/7R.png
// module id = 2251
// module chunks = 0